<script setup lang="ts">
import {trackEvent} from "@/services/event.service";

const model = defineModel();

defineEmits(['update:value'])

const props = defineProps({
  title: String,
  event_id: {
    type: String,
  },
  event_label: {
    type: String,
  },
  placeholder: {
    type: String,
    default: "Select filter"
  },
  value: {
    type: Array,
  },
  options: {
    type: Array,
    required: true,
  }
});

function handleChange(value: any[]) {
  const selectedLabels = props.options
      .filter(option => value.includes(option.value))
      .map(option => option.label);

  trackEvent(`cosmosy.ga.filters.${props.event_id}`, {
    event_label: props.event_label,
    selected_ids: value.join(','),
    selected_labels: selectedLabels.join(', '),
    selected_count: value.length
  });
}

</script>

<template>
  <div class="font-bold responsive-title-6">{{ props.title }}</div>
  <el-select
      v-model="model"
      multiple
      clearable
      collapse-tags
      collapse-tags-tooltip
      size="large"
      :placeholder="props.placeholder"
      :filterable="true"
      @change="handleChange"
  >
    <el-option
        v-for="item in props.options"
        :key="item.value"
        :label="item.label"
        :value="item.value"
    >
      <span class="text-black responsive-body-medium">{{ item.label }}</span>
    </el-option>
  </el-select>

</template>